module.exports = __webpack_public_path__ + "middleText-bg.png?eec4fc3e58e118f2a7a63cb87966e56a";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/middleText-bg.png
// module id = 2
// module chunks = 0